module.exports = __webpack_public_path__ + "static/media/Pattern-blue.9a877543.svg";